import PropTypes from 'prop-types';

import css from './index.module.scss';
import Image from '../Image';

const EventHeader = ({
  button,
  description,
  discloseSharedMarketing,
  disclosure,
  subtitle,
  name,
  image,
  imageTreatment,
}) => (
  <div className={css.root}>
    <div className={css.textWrap}>
      <div className={css.text}>
        <h1 className={css.title}>{name}</h1>
        {subtitle && <h2 className={css.subtitle}>{subtitle}</h2>}
        <div className={css.description} dangerouslySetInnerHTML={{ __html: description }} />
        {button && <div className={css.button}>{button}</div>}
        {discloseSharedMarketing && <div className={css.disclosure}>{disclosure}</div>}
      </div>
    </div>
    <div className={css.img}>
      <Image
        {...image}
        alt={name}
        sizes={[
          { size: 702, minWidth: 601 },
          { size: 600, minWidth: 351 },
          { size: 350, minWidth: 0 },
        ]}
        treatment={imageTreatment}
      />
    </div>
  </div>
);
EventHeader.defaultProps = {
  discloseSharedMarketing: false,
  disclosure: '',
  subtitle: false,
};
EventHeader.propTypes = {
  button: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.node]).isRequired,
  description: PropTypes.string.isRequired,
  discloseSharedMarketing: PropTypes.bool,
  disclosure: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string,
  }).isRequired,
  imageTreatment: PropTypes.string.isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  name: PropTypes.string.isRequired,
};

export default EventHeader;
